"use strict";

module.exports = /* @ngInject */ function(
  $q,
  RediWindowRepository,
  openFinApi
) {
  var that = this;

  that.setWindowInstanceAndInitialize = function(rediWindow, windowInstance) {
    return rediWindow.setWindowInstance(windowInstance).then(function() {
      return initializeRediWindow(rediWindow);
    });
  };

  function initializeRediWindow(rediWindow) {
    RediWindowRepository.addWindow(rediWindow);
    rediWindow.getNativeId().then(function(nativeId) {
      publishWindowChangeMessage(rediWindow, "window-opened", nativeId);
      rediWindow.onClosed(function() {
        publishWindowChangeMessage(rediWindow, "window-closed", nativeId);
        RediWindowRepository.removeWindow(rediWindow);
      });
    });
    return rediWindow;
  }

  function publishWindowChangeMessage(rediWindow, topic, nativeId) {
    openFinApi.publish(topic, {
      windowName: rediWindow.getName(),
      windowType: rediWindow.getType(),
      windowNativeId: nativeId
    });
  }
};



// WEBPACK FOOTER //
// ./app/infrastructure/RediWindowInstanceInitializer.js